import { render, staticRenderFns } from "./FolderSetup.vue?vue&type=template&id=a7980eaa&"
import script from "./FolderSetup.vue?vue&type=script&lang=ts&"
export * from "./FolderSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports